module.exports = __webpack_public_path__ + "assets/img/warrior-name-ab252833.png";